module.exports = __webpack_public_path__ + "img/pagebanner-story.29d278ab.jpg";